import { differenceInCalendarDays, isValid, parseISO } from 'date-fns';

/**
 * Days before check-in during which reservations are blocked and only
 * consultation (non-refundable-style inquiry) is allowed. 0 or unset disables it.
 */
function getBookingBlockDays(): number {
  const raw = Number(process.env.RAZZLE_HOTEL_BOOKING_BLOCK_DAYS);
  return Number.isFinite(raw) && raw > 0 ? raw : 0;
}

/**
 * True when checkIn falls within the configured block window (RAZZLE_HOTEL_BOOKING_BLOCK_DAYS
 * days from today), meaning the booking must be treated as non-refundable/consultation-only.
 */
export function isWithinBookingBlockWindow(checkIn: string | null | undefined): boolean {
  const blockDays = getBookingBlockDays();
  if (!blockDays || !checkIn) return false;

  const checkInDate = parseISO(checkIn);
  if (!isValid(checkInDate)) return false;

  const daysUntilCheckIn = differenceInCalendarDays(checkInDate, new Date());

  return daysUntilCheckIn <= blockDays;
}
